import shieldIconSrc from '@corbado/shared-ui/assets/shield.svg';
import { memo, useRef } from 'react';
import React from 'react';
import { useIconWithTheme } from '../../../hooks/useIconWithTheme';
import { Icon } from './Icon';
export const ShieldIcon = memo(props => {
    const svgRef = useRef(null);
    const { logoSVG } = useIconWithTheme(svgRef, shieldIconSrc, '--cb-passkey-list-badge-color');
    return (React.createElement(Icon, { src: logoSVG, ref: svgRef, alt: 'shield-icon', ...props }));
});
